export type CapacityUnit = 'TiB' | 'GiB';

export interface CapacityBounds {
  min: number;
  max: number;
}

export function tibToUnit(tib: number, unit: CapacityUnit): number {
  return unit === 'GiB' ? tib * 1024 : tib;
}

export function unitToTib(val: number, unit: CapacityUnit): number {
  return unit === 'GiB' ? val / 1024 : val;
}

export function formatCapacityValue(tib: number, unit: CapacityUnit): string {
  const v = tibToUnit(tib, unit);
  return unit === 'GiB' ? String(Math.round(v)) : String(Number(v.toFixed(2)));
}

export function isCapacityRangeNarrowed(
  minTib: number,
  maxTib: number,
  bounds: CapacityBounds
): boolean {
  return minTib > bounds.min || maxTib < bounds.max;
}

export function formatCapacityRangeBadge(
  minTib: number,
  maxTib: number,
  bounds: CapacityBounds
): string | undefined {
  if (!isCapacityRangeNarrowed(minTib, maxTib, bounds)) return undefined;

  const unit: CapacityUnit = maxTib < 1 ? 'GiB' : 'TiB';
  const lo = formatCapacityValue(minTib, unit);
  const hi = formatCapacityValue(maxTib, unit);
  return `${lo}-${hi} ${unit}`;
}
